import {LoginRegistrationProviders} from '~/shared/services/analytics/analyticsModels';

import {FormValues} from './types';

export enum ViewModes {
  SIGN_UP_MODE = 'signup',
  SIGN_IN_MODE = 'loginOrRegister',
}

export enum LoginProvider {
  GOOGLE = 'Google',
  TENBIS = 'Tenbis'
}

export const LOGIN_PROVIDER_ANALYTICS_MAP = {
  [LoginProvider.GOOGLE]: LoginRegistrationProviders.GOOGLE,
  [LoginProvider.TENBIS]: LoginRegistrationProviders.EMAIL,
};

export enum LoginOrRegisterScreenKey {
  LOGIN = 'login',
  SIGN_UP = 'signup',
  ADDRESS_FINDER = 'addressFinder'
}

export enum AuthFlowStep {
  INITIAL,
  PASSWORD,
  RESET_PASSWORD_SENT,
  OTP,
  ADD_ADDRESS
}

export const LOGIN_SCREEN_TYPES = {
  email: 'EMAIL_STEP',
  password: 'PASSWORD_STEP',
  verification: 'VERIFICATION_STEP',
};

export const initialFormValues: FormValues = {
  fullName: '',
  email: '',
  cellPhone: '',
  agreeToTerms: false,
  wantPromotion: false,
  googleCode: '',
};
